<template>
  <div class="page-membership">
    <router-link to="/" class="btn-back"><span>Back to Dashboard</span></router-link>
    <h1 class="h2">Membership</h1>
  </div>
</template>

<script>
export default {
  name: 'Membership',
};
</script>
